import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(Router);

// ===== 全局修复：忽略重复导航错误 =====
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};
// ===== 修复结束 =====

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    { path: '/education', name: 'Education', component: () => import('@/views/Education.vue') },
    { path: '/base', name: 'Base', component: () => import('@/views/Base.vue') },
    { path: '/restaurant', name: 'Restaurant', component: () => import('@/views/Restaurant.vue') },
    { path: '/businessservice', name: 'BusinessService', component: () => import('@/views/BusinessService.vue') },
    { path: '/highservice', name: 'HighService', component: () => import('@/views/HighService.vue') },
    { path: '/industrial-robot', name: 'IndustrialRobot', component: () => import('@/views/IndustrialRobot.vue') },
    { path: '/large-automation', name: 'LargeAutomation', component: () => import('@/views/LargeAutomation.vue') },
    { path: '/humanoidrobot', name: 'HumanoidRobot', component: () => import('@/views/HumanoidRobot.vue') },
    { path: '/medicalrobot', name: 'MedicalRobot', component: () => import('@/views/MedicalRobot.vue') },
    { path: '/introduction', name: 'Introduction', component: () => import('@/views/Introduction.vue') },
    { path: '/company/index', name: 'Company', component: () => import('@/views/company/Company.vue') },
    { path: '/company/businessservice', name: 'CompanyBusinessService', component: () => import('@/views/company/businessservice.vue') },
    { path: '/company/background', name: 'CompanyBackground', component: () => import('@/views/company/background.vue') },
    { path: '/company/history', name: 'CompanyHistory', component: () => import('@/views/company/companyhistory.vue') },
    { path: '/company/philosophy', name: 'CompanyPhilosophy', component: () => import('@/views/company/philosophy.vue') },
    { path: '/company/development', name: 'CompanyDevelopment', component: () => import('@/views/company/development.vue') },
    { path: '/robotics/education', name: 'RoboticsEducation', component: () => import('@/views/robotics/education.vue') },
    { path: '/robotics/base', name: 'RoboticsBase', component: () => import('@/views/robotics/base.vue') },
    { path: '/robotics/restaurant', name: 'RoboticsRestaurant', component: () => import('@/views/robotics/restaurant.vue') },
    { path: '/robotics/highservice', name: 'RoboticsHighservice', component: () => import('@/views/robotics/highservice.vue') },
    { path: '/robotics/industrial', name: 'RoboticsIndustrial', component: () => import('@/views/robotics/industrial.vue') },
    { path: '/robotics/large-automation', name: 'RoboticsLargeAutomation', component: () => import('@/views/robotics/large-automation.vue') },
    { path: '/robotics/humanoidrobot', name: 'RoboticsHumanoidRobot', component: () => import('@/views/robotics/humanoidrobot.vue') },
    { path: '/robotics/medicalrobot', name: 'RoboticsMedicalRobot', component: () => import('@/views/robotics/medicalrobot.vue') },
    { path: '/robot-introduction', name: 'RobotIntroduction', component: () => import('@/views/robot-introduction.vue') },
    { path: '/solutions', name: 'Solutions', component: () => import('@/views/solutions.vue') },
    { path: '/faq/platform', name: 'FaqPlatform', component: () => import('@/views/faq/frequently-platform.vue') },
    { path: '/faq/question', name: 'FaqQuestion', component: () => import('@/views/faq/frequently-question.vue') },
    // 其他路由可在此扩展
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});